/**
 * ============================================================
 *  مكتبة تصاميم الأبواب المستخدمة في مجسّم المدخل
 *  DOOR DESIGN LIBRARY FOR THE ENTRANCE VISUALIZER
 * ------------------------------------------------------------
 *  crop = [x0, y0, x1, y1] كنِسب من أبعاد الصورة الأصلية،
 *  وتحدّد مساحة درفة الباب فقط داخل الصورة.
 *  source: "apex"    = تشطيب حقيقي من أعمال APEX
 *  source: "concept" = نموذج تصميم توضيحي (ليس مشروعًا منفّذًا)
 *  hardware: true    = يُرسم مقبض وإطار ألمنيوم فوق التشطيب
 *
 *  لإضافة تصميم: أضف عنصرًا هنا فقط. لا حاجة لتعديل أي مكوّن.
 * ============================================================
 */

const A = "https://customer-assets-cm19k8pv.emergentagent.net/job_entrance-luxury-demo/artifacts";
const G = "https://static.prod-images.emergentagent.com/jobs/1ba39efd-cbb6-4386-b0c1-85129d975f16/images";

import { conceptDesigns } from "./designs";

/* لا تصاميم أساسية — كل خيارات المجسّم من مكتبة التصاميم المولَّدة */
const baseStyles = [];

/* التصاميم المفاهيمية المولَّدة تُضاف تلقائيًا كخيارات في المجسّم */
export const doorStyles = [
  ...baseStyles,
  ...conceptDesigns.map((c) => ({
    id: c.id,
    name_ar: c.title_ar,
    name_en: c.title_en,
    src: c.src,
    crop: c.crop,
    led: c.led,
    source: "concept",
    category: c.category,
    hardware: false,
    concept: true,
  })),
];

/* واجهة نموذجية للتجربة السريعة (من صور APEX) */
export const demoFacade = `${A}/hzrjqfh4_WhatsApp%20Image%202026-10-05%20at%2004.35.04%20%285%29.webp`;
